import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Career.css'; // Optional for styling

export default function Career() {
  const mailId = "info@smartvizx.com";
  const subject = "Application for an opportunity at Trezi";

  const mailToLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${mailId}&su=${encodeURIComponent(subject)}`;

  return (
    <>
      <Navbar />
      <main className="career-page container">
        <h2>Join Our Team</h2>
        <p className='careerp'>
          We’re always looking for passionate, talented individuals to join our growing team.  
          Please send your resume to <a href={`mailto:${mailId}`}>{mailId}</a> and we’ll get in touch.
        </p>

        <a href={mailToLink} target="_blank" rel="noopener noreferrer" className="send-mail-btn">
          Send Mail
        </a>

        <div className="career-links">
          <p>Explore more:</p>
          <ul>
            <li>
              <a href="https://www.linkedin.com/company/smartvizs-pvt-ltd-/" target="_blank" rel="noopener noreferrer">
                View Open Jobs on LinkedIn
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/lifeattrezi/" target="_blank" rel="noopener noreferrer">
                See Life at Trezi on Instagram
              </a>
            </li>
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
}
